(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["s7-hero"] && !Shopify.designMode) return;
  try {
    
  // Reduced motion: stop the download, not just the animation. CSS alone would
  // hide a video the browser had already fetched and started decoding.
  (function () {
    if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('.s7-hero__video').forEach(function (video) {
      video.removeAttribute('autoplay');
      video.pause();
      video.remove();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s7-main-addresses"]) return;
  try {
    
  // Deleting an address is irreversible and the button sits next to Edit.
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-confirm]');
    if (!btn) return;
    if (!window.confirm(btn.dataset.confirm)) ev.preventDefault();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s7-movement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('.s7-movement__video').forEach(function (v) {
      v.removeAttribute('autoplay');
      v.pause();
      v.remove();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
